import { delayForMs } from "../../utils/delayFor";
import { taskActivityKeyMaker } from "../hooks/useGetTaskActivity";
import { taskCommentsKeyMaker } from "../hooks/useGetTaskComments";
export const activityLogDelay = delayForMs([100, 200, 500, 1000, 4000, 6000]);
export const refetchActivityLog = async (taskId, queryClient) => {
    await Promise.all([
        queryClient.refetchQueries(taskCommentsKeyMaker(taskId, null)),
        queryClient.refetchQueries(taskActivityKeyMaker(taskId, null)),
    ]);
};
export const refetchActivityLogWithDelay = async (taskId, queryClient) => {
    activityLogDelay(async () => await refetchActivityLog(taskId, queryClient));
};
//# sourceMappingURL=refetchActivityLog.js.map